const toString = Object.prototype.toString

export function is(val: unknown, type: string) {
  return toString.call(val) === `[object ${type}]`
}

export function isDef(val: unknown) {
  return typeof val !== 'undefined'
}

export function isUndef(val: unknown) {
  return typeof val === 'undefined'
}

export function isNull(val: unknown) {
  return val === null
}

export function isWhitespace(val: string) {
  return val === ''
}

export function isObject(val: unknown) {
  return !isNull(val) && is(val, 'Object')
}

export function isArray(val: unknown[]) {
  return val && Array.isArray(val)
}

export function isString(val: unknown) {
  return is(val, 'String')
}

export function isNumber(val: unknown) {
  return is(val, 'Number')
}

export function isBoolean(val: unknown) {
  return is(val, 'Boolean')
}

export function isDate(val: unknown) {
  return is(val, 'Date')
}

export function isRegExp(val: unknown) {
  return is(val, 'RegExp')
}

export function isFunction(val: unknown) {
  return typeof val === 'function'
}

export function isElement(val: HTMLElement) {
  return isObject(val) && !!val.tagName
}

export function isWindow(val: unknown) {
  return typeof window !== 'undefined' && isDef(window) && is(val, 'Window')
}

export function isNullOrUndef(val: unknown) {
  return isNull(val) || isUndef(val)
}

export function isNullOrWhitespace(val: string) {
  return isNullOrUndef(val) || isWhitespace(val)
}

export function isEmpty(val: any) {
  if (isArray(val) || isString(val)) return val.length === 0

  if (val instanceof Map || val instanceof Set) return val.size === 0

  if (isObject(val)) return Object.keys(val).length === 0

  return false
}

/**
 * * 类似mysql的IFNULL函数
 * * 第一个参数为null/undefined/'' 则返回第二个参数作为备用值，否则返回第一个参数
 * @param {Number|Boolean|String} val
 * @param {Number|Boolean|String} def
 * @returns
 */
export function ifNull(val = '', def = '') {
  return isNullOrWhitespace(val) ? def : val
}

export function isUrl(path = '') {
  const reg =
    /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/
  return reg.test(path)
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path: string) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export const isServer = typeof window === 'undefined'

export const isClient = !isServer
